import { FC } from "react";
import { HeadsUpViewState } from "@/components/heads-up/context/heads-up-context";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds";
import styled from "@emotion/styled";
import { motion } from "motion/react";

interface HeadsUpSidebarSubheaderProps {
  viewState: HeadsUpViewState;
  formattedRelativeTime: string | null;
}

export const HeadsUpSidebarSubheader: FC<HeadsUpSidebarSubheaderProps> = ({
  viewState,
  formattedRelativeTime,
}) => {
  /**
   * We only show the footer when we have generated some content.
   */
  if (viewState !== HeadsUpViewState.GeneratedHasContent) {
    return <SubheaderContainer />;
  }

  if (!formattedRelativeTime) {
    return <SubheaderContainer />;
  }

  return (
    <SubheaderContainer>
      <AnimatedView
        key={viewState}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        <MDSText
          variant={MDSTextVariant.TextXs}
          weight={MDSTextWeight.Regular}
          color={MDSTextColor.Secondary}
        >
          {formattedRelativeTime}
        </MDSText>
      </AnimatedView>
    </SubheaderContainer>
  );
};

const SubheaderContainer = styled.div`
  height: 22px;
  min-height: 22px;
  min-width: 1px;
  display: block;
`;

const AnimatedView = styled(motion.div)``;
